// Feature: docs/features/payer-response-auto-load.md
import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Card,
  CardBody,
  Badge,
  Button,
  Spinner,
  Center,
  Alert,
  AlertIcon
} from '@chakra-ui/react';
import { AppContext } from './AppContext';
import { callApi } from '../callApi';
import HeaderMenus from './HeaderMenus';

const PayerResponseQueue = () => {
  const { accessToken } = useContext(AppContext);
  const navigate = useNavigate();
  const [queue, setQueue] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchQueue = async () => {
      if (!accessToken) return;
      try {
        const response = await callApi('/api/v2/payer-responses/queue', accessToken);
        const data = await response.json();
        
        if (response.ok && data.success) {
          setQueue(data.queue);
        } else {
          throw new Error(data.error || 'Failed to fetch queue');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchQueue();
  }, [accessToken]);

  const handleRowClick = (caseId) => {
    navigate(`/payer-response-intelligence/${caseId}`);
  };

  return (
    <Box>
      <HeaderMenus />
      <Container maxW="container.xl" py={8}>
        <VStack spacing={6} align="stretch">
          <Box>
            <Heading size="lg" mb={2}>Denials Work Queue</Heading>
            <Text color="gray.600">
              Cases with processed Payer Response intelligence.
            </Text>
          </Box>

          {error && (
            <Alert status="error">
              <AlertIcon />
              {error}
            </Alert>
          )}

          <Card shadow="md">
            <CardBody p={0}>
              {isLoading ? (
                <Center p={10}>
                  <Spinner size="xl" color="blue.500" />
                </Center>
              ) : queue.length === 0 ? (
                <Center p={10}>
                  <Text color="gray.500">No processed Payer Responses found.</Text>
                </Center>
              ) : (
                <Table variant="simple">
                  <Thead bg="gray.50">
                    <Tr>
                      <Th>Case ID</Th>
                      <Th>Claims</Th>
                      <Th textAlign="right">Action</Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {queue.map((item) => (
                      <Tr 
                        key={item.case_id} 
                        _hover={{ bg: 'gray.50', cursor: 'pointer' }}
                        onClick={() => handleRowClick(item.case_id)}
                      >
                        <Td fontWeight="medium" color="blue.600">{item.case_id}</Td>
                        <Td>
                          {item.claims.map(claim => (
                            <Badge key={claim} mr={2} colorScheme="purple">{claim}</Badge>
                          ))}
                        </Td>
                        <Td textAlign="right">
                          <Button size="sm" colorScheme="blue" variant="outline">
                            View Analysis
                          </Button>
                        </Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table>
              )}
            </CardBody>
          </Card>
        </VStack>
      </Container>
    </Box>
  );
};

export default PayerResponseQueue;